import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Foot from '@/pages/foot'
import Home from '@/pages/home'
import Aboutus from '@/pages/aboutus'
import Product from '@/pages/product'
import Wlhy from '@/pages/product/wlhy'
import Etc from '@/pages/product/etc'
import Tms from '@/pages/product/tms'
import Wms from '@/pages/product/wms'
import Solution from '@/pages/solution'
import News from '@/pages/news'
import NewsDetail from '@/pages/newsDetail'
import Contactus from '@/pages/contactus'
import Service from '@/pages/service'
import Position from '@/pages/service/position'
import Locus from '@/pages/service/locus'
import Defend from '@/pages/service/defend'
import ContractAdd from '@/pages/service/add'
import Commission from '@/pages/service/commission'
import Insurance from '@/pages/service/insurance'
import Access from '@/pages/service/access'
import Login from '@/pages/login'
import Register from '@/pages/register'
import User from '@/pages/user'
import Pay from '@/pages/pay'
import Download from '@/pages/download'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/',
          component: Foot,
          children: [
            { path: '/',component: Home },
            { path: '/aboutus',component: Aboutus },
            {
              path: '/product',
              component: Product,
              children: [
                { path: '/product',component: Wlhy },
                { path: '/product/etc',component: Etc },
                { path: '/product/tms',component: Tms },
                { path: '/product/wms',component: Wms }
              ]
            },
            { path: '/solution',component: Solution },
            { path: '/news',component: News },
            { path: '/news/detail',component: NewsDetail },
            { path: '/contactus',component: Contactus },
            {
              path: '/service',
              component: Service,
              children: [
                { path: '/service',component: Position },
                { path: '/service/locus',component: Locus },
                { path: '/service/defend',component: Defend },
                { path: '/service/add',component: ContractAdd },
                { path: '/service/commission',component: Commission },
                { path: '/service/insurance',component: Insurance },
                { path: '/service/access',component: Access }
              ]
            },
            { path: '/user',component: User }
          ]
        },
        { path: '/login',component: Login },
        { path: '/register',component: Register }
      ]
    }, {
      path: '/pay',
      name: 'pay',
      component: Pay
    },
    {
      path: '/download',
      component: Download
    },
  ]
});

router.beforeEach((to, from, next) => {
  if ((!document.cookie || document.cookie === '') && (to.path === '/user' || to.path.indexOf('/service') != -1)) {
    Vue.prototype.$message.error('用户信息已过期，请重新登录');
    Vue.prototype.$store.commit('loginChange', false);
    next({ path: '/login' });
  } else {
    next();
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js